import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LayoutService } from './app/layout/service/layout.service';
import { LoginInativoDialogComponent } from './app/components/login-inativo-dialog/login-inativo-dialog.component';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterModule, LoginInativoDialogComponent],
    template: `<router-outlet></router-outlet> <app-login-inativo-dialog></app-login-inativo-dialog>`
})
export class AppComponent {
    layoutService: LayoutService = inject(LayoutService);

    ngOnInit() {
        this.themeSelected();
    }

    themeSelected() {
        const theme = localStorage.getItem('theme');
        const isDark = theme === 'dark';

        this.layoutService.layoutConfig.update((state) => ({
            ...state,
            darkTheme: isDark,
            menuTheme: isDark ? 'dark' : 'light',
            topbarTheme: isDark ? 'dark' : 'light',
        }));

        if (isDark) {
            document.documentElement.classList.add('app-dark');
        } else {
            document.documentElement.classList.remove('app-dark');
        }
    }
}
